import { UpdateKeysAction, UPDATE_ROW_KEYS } from './types'
import { KeyFigure } from '../../../types/keyFigure/KeyFigure'

export const updateRowKeys = (keys: KeyFigure['id'][]): UpdateKeysAction => ({
  type: UPDATE_ROW_KEYS,
  keys
})
